// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================
   BREAKPOINTS
============================ */
/* ============================
   HELPERS
============================ */
.clinic-section {
  display: flex;
  justify-content: center;
  background: #f0f0f5;
  margin-top: 6rem;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}
@media (max-width: 768px) {
  .clinic-section {
    margin: 4rem 1rem 0;
    border-radius: 12px;
  }
}
@media (max-width: 576px) {
  .clinic-section {
    margin: 3rem 0.75rem 0;
    border-radius: 8px;
  }
}
.clinic-section {
  /* =========================
     MAIN CONTAINER
  ========================= */
}
.clinic-section__container {
  max-width: 1400px;
  width: 100%;
  padding: clamp(40px, 6vw, 70px) clamp(20px, 4vw, 60px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(2rem, 6vw, 4rem);
}
@media (max-width: 992px) {
  .clinic-section__container {
    flex-direction: column;
    text-align: center;
    gap: 2rem;
  }
}
.clinic-section {
  /* =========================
     IMAGE CARD
  ========================= */
}
.clinic-section .clinic-card {
  flex-shrink: 0;
}
.clinic-section .clinic-card img {
  width: clamp(280px, 35vw, 380px);
  aspect-ratio: 4/5;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
@media (max-width: 768px) {
  .clinic-section .clinic-card img {
    max-width: 420px;
    width: 100%;
  }
}
.clinic-section {
  /* =========================
     TEXT CONTENT
  ========================= */
}
.clinic-section .clinic-content {
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  color: #111827;
  line-height: 1.7;
}
@media (max-width: 992px) {
  .clinic-section .clinic-content {
    max-width: 700px;
  }
}
@media (max-width: 768px) {
  .clinic-section .clinic-content {
    max-width: 100%;
  }
}
.clinic-section .clinic-content .clinic-subtitle {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e2150;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  opacity: 0.9;
}
.clinic-section .clinic-content .clinic-title {
  font-size: clamp(1.4rem, 4vw, 2rem);
  font-weight: 800;
  color: #1e2150;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}
.clinic-section .clinic-content .clinic-text {
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  color: #555;
  line-height: 1.7;
}
@media (max-width: 992px) {
  .clinic-section .clinic-content .clinic-text {
    text-align: center;
  }
}
@media (max-width: 576px) {
  .clinic-section .clinic-content .clinic-text {
    text-align: left;
    font-size: 0.9rem;
  }
}
.clinic-section .clinic-content .btn {
  margin-top: 1rem;
  align-self: flex-start;
}
@media (max-width: 992px) {
  .clinic-section .clinic-content .btn {
    align-self: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/styles/styleHomePage/clinicSection.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;;8BAAA;AAsBA;;8BAAA;ACrBA;EACE,aAAA;EACA,uBAAA;EACA,mBC0BO;EDzBP,gBAAA;EACA,mBC0CU;EDzCV,0CAAA;AAIF;ADGI;ECbJ;IASI,mBAAA;IACA,mBCoCQ;ED/BV;AACF;ADHI;ECbJ;IAcI,sBAAA;IACA,kBC8BQ;EDxBV;AACF;AAtBA;EAkBE;;6BAAA;AASF;AANE;EACE,iBCWQ;EDVR,WAAA;EACA,sDAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAOJ;ADvBI;ECQF;IAWI,sBAAA;IACA,kBAAA;IACA,SAAA;EAQJ;AACF;AA3CA;EAsCE;;6BAAA;AAUF;AAPE;EACE,cAAA;AASJ;AAPI;EACE,gCAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBCFM;EDGN,0CAAA;AASN;AD7CI;ECwCE;IACE,gBAAA;IACA,WAAA;EAQN;AACF;AAhEA;EA4DE;;6BAAA;AASF;AANE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cC7CG;ED8CH,gBAAA;AAQJ;ADhEI;ECkDF;IASI,gBAAA;EASJ;AACF;ADrEI;ECkDF;IAaI,eAAA;EAUJ;AACF;AARI;EACE,iBAAA;EACA,gBAAA;EACA,cCpEO;EDqEP,yBAAA;EACA,qBAAA;EACA,YAAA;AAUN;AAPI;EACE,mCAAA;EACA,gBAAA;EACA,cC7EO;ED8EP,gBAAA;EACA,qBAAA;AASN;AANI;EACE,qCAAA;EACA,WCzEO;ED0EP,gBAAA;AAQN;AD9FI;ECmFA;IAMI,kBAAA;EASN;AACF;ADnGI;ECmFA;IAUI,gBAAA;IACA,iBAAA;EAUN;AACF;AAPI;EACE,gBAAA;EACA,sBAAA;AASN;AD7GI;ECkGA;IAKI,kBAAA;EAUN;AACF","sourcesContent":["@use \"./variables\" as v;\r\n\r\n/* ============================\r\n   BREAKPOINTS\r\n============================ */\r\n$breakpoints: (\r\n        xs: 480px,\r\n        sm: 576px,\r\n        md: 768px,\r\n        lg: 992px,\r\n        xl: 1200px,\r\n        xxl: 1400px\r\n);\r\n\r\n@mixin respond($bp) {\r\n  @if map-has-key($breakpoints, $bp) {\r\n    @media (max-width: map-get($breakpoints, $bp)) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @warn \"No breakpoint found: #{$bp}\";\r\n  }\r\n}\r\n\r\n/* ============================\r\n   HELPERS\r\n============================ */\r\n@mixin flex-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@mixin truncate-text($lines: 1) {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: $lines;\r\n  -webkit-box-orient: vertical;\r\n}\r\n","@use \"../variables\" as v;\r\n@use \"../mixins\" as m;\r\n\r\n.clinic-section {\r\n  display: flex;\r\n  justify-content: center;\r\n  background: v.$bg-alt;\r\n  margin-top: 6rem;\r\n  border-radius: v.$radius-lg;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n\r\n  @include m.respond(md) {\r\n    margin: 4rem 1rem 0;\r\n    border-radius: v.$radius-md;\r\n  }\r\n\r\n  @include m.respond(sm) {\r\n    margin: 3rem 0.75rem 0;\r\n    border-radius: v.$radius-sm;\r\n  }\r\n\r\n  /* =========================\r\n     MAIN CONTAINER\r\n  ========================= */\r\n  &__container {\r\n    max-width: v.$max-width;\r\n    width: 100%;\r\n    padding: clamp(40px, 6vw, 70px) clamp(20px, 4vw, 60px);\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: clamp(2rem, 6vw, 4rem);\r\n\r\n    @include m.respond(lg) {\r\n      flex-direction: column;\r\n      text-align: center;\r\n      gap: 2rem;\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     IMAGE CARD\r\n  ========================= */\r\n  .clinic-card {\r\n    flex-shrink: 0;\r\n\r\n    img {\r\n      width: clamp(280px, 35vw, 380px);\r\n      aspect-ratio: 4 / 5;\r\n      object-fit: cover;\r\n      border-radius: v.$radius-md;\r\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\r\n    }\r\n\r\n    @include m.respond(md) {\r\n      img {\r\n        max-width: 420px;\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     TEXT CONTENT\r\n  ========================= */\r\n  .clinic-content {\r\n    max-width: 520px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    color: v.$dark;\r\n    line-height: 1.7;\r\n\r\n    @include m.respond(lg) {\r\n      max-width: 700px;\r\n    }\r\n\r\n    @include m.respond(md) {\r\n      max-width: 100%;\r\n    }\r\n\r\n    .clinic-subtitle {\r\n      font-size: 0.9rem;\r\n      font-weight: 600;\r\n      color: v.$brand-blue;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.4px;\r\n      opacity: 0.9;\r\n    }\r\n\r\n    .clinic-title {\r\n      font-size: clamp(1.4rem, 4vw, 2rem);\r\n      font-weight: 800;\r\n      color: v.$brand-blue;\r\n      line-height: 1.2;\r\n      margin-bottom: 0.5rem;\r\n    }\r\n\r\n    .clinic-text {\r\n      font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n      color: v.$text-muted;\r\n      line-height: 1.7;\r\n\r\n      @include m.respond(lg) {\r\n        text-align: center;\r\n      }\r\n\r\n      @include m.respond(sm) {\r\n        text-align: left;\r\n        font-size: 0.9rem;\r\n      }\r\n    }\r\n\r\n    .btn {\r\n      margin-top: 1rem;\r\n      align-self: flex-start;\r\n\r\n      @include m.respond(lg) {\r\n        align-self: center;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
